import React from "react";
import ServiceHero from "../../components/ServiceHero";

const SocialMediaMarkectingHome = () => (
  <ServiceHero
    eyebrow="Social Media Marketing"
    title="Turn every scroll into"
    highlight="meaningful connection."
    description="We create social strategies and content that sound like your brand, earn attention in busy feeds, and build an audience that wants to stay engaged."
    features={[
      "Platform-specific strategy",
      "Creative that stops the scroll",
      "Community and campaign growth",
    ]}
    image="/Images/SocialMedia1.png"
    imageAlt="Illustration of social media content, conversations, and engagement"
    visualLabel="Social built around people"
    visualTitle="From passive followers to an active brand community."
  />
);

export default SocialMediaMarkectingHome;
